import moment from 'moment';
import { SnackbarProvider, useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import { DotLoaderOverlay } from 'react-spinner-overlay';

/** Servicios */
import correoService from '../services/correo.service';
import emailService from '../services/email.service';
import mutuoService from '../services/mutuo.service';
import proyectoService from '../services/proyecto.service';
import usuarioService from '../services/usuario.service';

/** MUI NUEVO */
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { TextField } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import Collapse from '@mui/material/Collapse';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import { styled } from '@mui/material/styles';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const MutuoGerGen = () => {
    const { id_mutuo } = useParams();
    const [causal, setCausal] = useState('');
    const [persona, setPersona] = useState('');
    const [expanded, setExpanded] = React.useState(false);
    const [sigPad, setSigPad] = useState({});
    const { enqueueSnackbar } = useSnackbar();
    const [correos, setCorreos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    let navigate = useNavigate();
    const [rechazo, setRechazo] = useState(false);
    const [motivoRechazo, setMotivoRechazo] = useState('');
    const [mutuo, setMutuo] = useState('');

    useEffect(() => {
        retreiveMutuo(id_mutuo);
        retreiveCorreos();
    }, []);

    async function retreiveMutuo(id_mutuo) {
        setLoading(true);
        try {
            let m = await mutuoService.getByID(id_mutuo);
            setMutuo(m.data);
            setPersona(m.data.persona);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }

    function retreiveCorreos() {
        correoService.getAll()
            .then(resp => {
                console.log(resp.data);
                setCorreos(resp.data);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const limpiarFirma = () => {
        sigPad.clear();
    }

    const ingresar = () => {
        if (sigPad.isEmpty()) {
            alert("Ingrese Firma");
            return;
        }
        setLoading(true);
        var f = sigPad.toDataURL();
        var fr = f.split(',');

        /* const dataap = {
            tipo: "GERENCIA GENERAL",
            fecha: Date.now(),
            firma: fr[1],
            id_causal: causal.id
        }
        aprobadorService.ingresar(dataap)
            .then(a => {
                console.log(a);
            })
            .catch(err => {
                console.error(err);
            }); */
        //Mandamos el mail
        var html = crearHtmlEnvio(new Date().toString(), mutuo.id, persona);
        var send = [];
        send.push("plagues@ecora.cl");
        send.push(mutuo.correo_usuario);
        /* var crr = correos.filter(v => v.destino === "FINANZAS2");
        var send = [];
        if (crr) {
            for (var i in crr) {
                send.push(crr[i].correo);
            }
        } */
        const _data_mail = {
            nombre: "RRHH",
            mensaje: html,
            email: send
        }
        //Envío correo a RRHH
        emailService.sendMailMutuo(_data_mail)
            .then(async response => {
                console.log(response);
                //const pers = await personaService.update(persona.id, {estado_desv: "En Proceso de Finanzas - Ultima etapa"});
                //console.log(pers.data);
                setLoading(false);
                enqueueSnackbar('Solicitud enviada correctamente!', { variant: "success" });
                setTimeout(() => {
                    navigate("/salidar");
                }, 2000);
            })
            .catch(e => {
                console.log(e);
                setLoading(false);
                enqueueSnackbar('Error al enviar correo!', { variant: "error" });
            });
    }

    function crearHtml(fecha, mutuo_id, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Solicitud de Información de Mutuo Acuerdo</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha comentado la Solicitud de Información de Mutuo Acuerdo para la persona: ${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</p><p>Para su revisón, por favor ir al siguiente Link: <a href="${baseurl}/mutuoadcfinal/${mutuo_id}"</p>`;
        html = html + "</div>";
        return html;
    }

    function crearHtmlEnvio(fecha, mutuo_id, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:#90c7fe;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Solicitud de Información de Mutuo Acuerdo</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha <strong>aprobado</strong> la Solicitud de Información de Mutuo Acuerdo, por favor revisar a traves del siguiente link: </p> <a href="${baseurl}/mutuoadcfinal/${mutuo_id}">${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</a> \n`;
        html = html + "</div>";
        return html;
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        navigate("/desvincular");
    };

    const rechazarDesv = () => {
        setRechazo(!rechazo);
    }

    const enviarRechazo = async () => {
        console.log("Motivo rechazo", motivoRechazo);
        if (motivoRechazo === "") {
            alert("Ingrese un motivo de rechazo");
            return;
        }
        setLoading(true);
        try {
            //Enviamos Mail a RRHH que se rechazo por gerencia la desvinculacion
            var html = crearHtmlRechazo(new Date().toString(), 0, 0, persona);
            var crr = correos.filter(v => v.destino === "RRHH" & v.proyecto === persona.ctoDescripcion);
            var crr_ger = correos.filter(v => v.destino === "GERENCIA" & v.proyecto === persona.ctoDescripcion);
            //Traemos los proyectos
            const proy = await proyectoService.getAll();
            var proy_adc = proy.data.filter(v => v.nombre === persona.ctoDescripcion);
            console.log("Proy ADC", proy_adc);
            const user = await usuarioService.get(proy_adc[0].usuarioId);
            console.log("Usuario Rechazo", user.data);
            var send = [];
            //send.push("vbarreda@ecora.cl");
            if (crr) {
                for (var i in crr) {
                    send.push(crr[i].correo);
                }
            }
            if (user) {
                send.push(user.data.correo);
            }
            if (crr_ger) {
                for (var i in crr_ger) {
                    send.push(crr_ger[i].correo);
                }
            }
            const _data_mail = {
                nombre: "RRHH",
                mensaje: html,
                email: send
            }
            //Envío mail a RRHH indicando que Gerencia rechazo la desvinculacion
            let mail = emailService.sendMailMutuo(_data_mail);
            if (mail) {
                enqueueSnackbar("Rechazo enviado correctamente!!", { variant: "success" });
                setLoading(false);
                setTimeout(() => {
                    navigate("/salidar");
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            enqueueSnackbar("Ocurrio un error!!", { variant: "error" });
            setLoading(false);
        }
    }

    function crearHtmlRechazo(fecha, causal, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Solicitud de Información de Mutuo Acuerdo</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha <strong>rechazado</strong> la Solicitud de Mutuo Acuerdo para la persona: ${persona.Rut + ' - ' + persona.perNombre1 + ' ' + persona.perApPaterno} </p> \n <p>con el siguiente motivo: ${motivoRechazo}</p>`;
        html = html + "</div>";
        return html;
    };

    const abrirRuta = () => {
        window.open(mutuo.url, "_blank");
    }

    return (
        <Container component="main" maxWidth="xs">
            {loading ? (
                <DotLoaderOverlay size={28} message="Cargando..." color="#4F8BFA" />
            ) : ""}
            <Card sx={{ maxWidth: 345 }}>
                <CardHeader
                    avatar={
                        <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                            {persona ? persona.perNombre1.charAt(0).toUpperCase() : ""}
                        </Avatar>
                    }
                    action={
                        <IconButton aria-label="settings">
                            <MoreVertIcon />
                        </IconButton>
                    }
                    title={persona.perNombre1 + " " + persona.perApPaterno + " " + persona.perApMaterno}
                    subheader={persona.Rut}
                />
                <CardMedia
                    component="img"
                    height="194"
                    image="/logo512.png"
                    alt="Ecora S.A."
                />
                <CardContent>
                    {/* <Typography variant="body2" color="text.secondary">
                        <p><strong>Causal:</strong> {causal.descripcion}</p>
                        <p><strong>Comentarios:</strong> {causal.comentario}</p>
                        <p><strong>Evaluación:</strong> {causal.evaluacion}</p>
                        <p><strong>Fecha Ingreso Desvinculación:</strong> {moment(causal.fecha_ingreso).format("DD-MM-YYYY")}</p>
                    </Typography> */}
                    <Typography variant='6' sx={{
                        fontStyle: "inherit",
                        fontWeight: "bold"
                    }}>
                        Datos Trabajador
                    </Typography>
                    <Typography paragraph sx={{marginTop: 3}}>
                        <p><strong>Unidad de Negocio:</strong> {persona.ctoDescripcion}</p>
                        <p><strong>Cargo:</strong> {persona.recDescripcion}</p>
                        <p><strong>Fecha de Contrato:</strong> {moment(persona.FechaContratoInicial).format("DD-MM-YYYY")}</p>
                    </Typography>
                    <Typography paragraph>
                        {/* <p>{mutuo.comentario_final}</p> */}
                        <Button variant="contained" onClick={abrirRuta}>DESCARGAR CARTA</Button>
                    </Typography>
                </CardContent>
                {/* <CardActions disableSpacing>
                    <Typography variant='6' sx={{
                        fontStyle: "inherit",
                        fontWeight: "bold"
                    }}>
                        Datos Trabajador
                    </Typography>
                    <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon />
                    </ExpandMore>
                </CardActions> */}
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        <Typography paragraph>
                            <p><strong>Unidad de Negocio:</strong> {persona.ctoDescripcion}</p>
                            <p><strong>Cargo:</strong> {persona.recDescripcion}</p>
                            <p><strong>Fecha de Contrato:</strong> {moment(persona.FechaContratoInicial).format("DD-MM-YYYY")}</p>
                        </Typography>
                    </CardContent>
                </Collapse>
            </Card>
            <Typography variant='h6' sx={{
                marginTop: 3
            }}>
                Ingresar Firma:
            </Typography>
            <Box sx={{
                marginTop: 1,
                justifyContent: "center",
                alignItems: "center",
                display: "flex"
            }}>
                <SignatureCanvas
                    canvasProps={{
                        className: "sginatureCanvas"
                    }}
                    ref={(ref) => { setSigPad(ref) }}
                />
            </Box>
            <Box sx={{
                margin: 1,
                justifyContent: "end",
                alignItems: "end",
                display: "flex"
            }}>
                <Button variant='outlined' color='info' onClick={limpiarFirma}>Limpiar Firma</Button>
            </Box>
            <Box sx={{
                margin: 3,
                justifyContent: "end",
                alignItems: "end",
                display: "flex"
            }}>
                <Stack direction="row" spacing={3}>
                    <Button variant='contained' onClick={ingresar}>APROBAR</Button>
                    <Button variant='contained' color='secondary' onClick={rechazarDesv}>RECHAZAR</Button>
                </Stack>
            </Box>
            {rechazo ? (
                <FormControl fullWidth>
                    <FormLabel>Motivo del Rechazo:</FormLabel>
                    <TextField
                        placeholder="Ingrese motivo aqui..."
                        multiline
                        fullWidth
                        minRows={3}
                        autoFocus
                        onChange={(e) => setMotivoRechazo(e.target.value)}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 'var(--Textarea-paddingBlock)',
                            pt: 'var(--Textarea-paddingBlock)',
                            borderTop: '1px solid',
                            borderColor: 'divider',
                            flex: 'auto',
                        }}
                    >
                        <Button variant='contained' onClick={enviarRechazo} sx={{ ml: 'auto', mt: 1, mb: 1 }}>Enviar</Button>
                    </Box>
                </FormControl>
            ) : ""}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Trabajador en Proceso de Desvinculación"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        El trabajador ya se encuentra en proceso de desvinculación, por favor comuniquese con el
                        departamento de RRHH.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Aceptar</Button>
                    {/* <Button onClick={handleClose} autoFocus>
                        Agree
                    </Button> */}
                </DialogActions>
            </Dialog>
        </Container>
    )
}

export default function MutuoGerGenSnack() {
    return (
        <SnackbarProvider maxSnack={3}>
            <MutuoGerGen />
        </SnackbarProvider>
    )
}